import { mqMin, radius, space, tok } from '@sunwebgroup/ui-components'
import * as React from 'react'

import { styled } from 'styled-components'

import { Filters } from './Filters'
import { SelectedFiltersTokens } from './SelectedFiltersTokens'

const Wrapper = styled.div`
  display: none;
  align-self: start;
  flex: 0 0 400px; // This needs to be removed once we deal with the parent wrapper
  padding: ${space('primitives_space_24')};
  min-width: 0;
  margin-top: ${space('primitives_space_32')};
  border-radius: ${radius('semantics_boxes_corner_radius')};
  background-color: ${tok('semantics_backgrounds_background_color')};

  @media ${mqMin('primitives_breakpoint_l_min')} {
    display: initial;
  }
`

const DesktopOnly = styled.div`
  display: none;
  @media ${mqMin('primitives_breakpoint_l_min')} {
    display: initial;
  }
`

export function SideBar() {
  return (
    <Wrapper>
      <DesktopOnly>
        <SelectedFiltersTokens withResetButton />
      </DesktopOnly>
      <Filters />
    </Wrapper>
  )
}
